export const toBase64 = (file: File): Promise<string | ArrayBuffer | null> => {
  return new Promise<string | ArrayBuffer | null>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = (): void => resolve(reader.result);

    reader.onerror = (error: ProgressEvent<FileReader>): void => reject(error);
  });
};
